export const FinpromVerificationStepKeys = {
  RISK_WARNING: 'riskWarning',
  SELF_CATEGORISATION: 'selfCategorisation',
  APPROPRIATENESS_TEST: 'appropriatenessTest',
} as const

export const FinpromVerificationStepList = Object.values(FinpromVerificationStepKeys)

export const FinpromStepKeys = {
  INITIAL: 'initial',
  ...FinpromVerificationStepKeys,
  COOL_OFF: 'cool-off',
} as const

export const SelfCategorisationStepKeys = {
  SELECT_CATEGORY: 'selectCategory',
  CONFIRM_CATEGORY: 'confirmCategory',
} as const

export const selfCategorisationStepList = Object.values(SelfCategorisationStepKeys)

export const SelfCategorisationCategories = {
  RESTRICTED: 'restricted',
  HIGH_NET_WORTH: 'highNetWorth',
  SOPHISTICATED: 'sophisticated',
} as const

export const selfCategorisationCategoryList = Object.values(SelfCategorisationCategories)
